import {
    DashboardIcon,
    DiscoveryIcon,
    ExploreIcon,
    IconBook,
    IconBundle,
    IconManage,
    IconMeasure,
    InfluencersIcon,
    IconInvoice,
    MessagesIcon,
    OffersIcon,
    PlannerIcon,
    ReportingIcon,
} from '../Icons';
import { CgMoreVertical } from 'react-icons/cg';

const agencyMobileLinks = [
    {
        tabKey: 'influencers',
        title: 'influencer.campaign.tabs.influencers',
        icon: InfluencersIcon,
    },
    {
        tabKey: 'dashboard',
        title: 'influencer.campaign.tabs.dashboard',
        icon: DashboardIcon,
    },
    {
        tabKey: 'explore',
        title: 'influencer.campaign.tabs.explore',
        icon: ExploreIcon,
    },
    {
        tabKey: 'more',
        title: 'influencer.campaign.tabs.more',
        icon: CgMoreVertical,
        moreTabs: [
            {
                tabKey: 'invoices',
                title: 'influencer.campaign.tabs.invoices',
                icon: IconInvoice,
            },
            {
                tabKey: 'offers',
                title: 'influencer.campaign.tabs.offers',
                icon: OffersIcon,
            },
            {
                tabKey: 'planner',
                title: 'influencer.campaign.tabs.planner',
                icon: PlannerIcon,
            },
            {
                tabKey: 'reporting',
                title: 'influencer.campaign.tabs.reporting',
                icon: ReportingIcon,
            },
            {
                tabKey: 'messages',
                title: 'influencer.campaign.tabs.messages',
                icon: MessagesIcon,
            },
        ],
    },
];

const agencyDesktopLinks = [
    {
        tabKey: 'influencers',
        title: 'influencer.campaign.tabs.influencers',
        icon: InfluencersIcon,
    },
    {
        tabKey: 'dashboard',
        title: 'influencer.campaign.tabs.dashboard',
        icon: DashboardIcon,
    },
    {
        tabKey: 'explore',
        title: 'influencer.campaign.tabs.explore',
        icon: ExploreIcon,
    },
    {
        tabKey: 'offers',
        title: 'influencer.campaign.tabs.offers',
        icon: OffersIcon,
    },
    {
        tabKey: 'planner',
        title: 'influencer.campaign.tabs.planner',
        icon: PlannerIcon,
    },
    {
        tabKey: 'reporting',
        title: 'influencer.campaign.tabs.reporting',
        icon: ReportingIcon,
    },
    {
        tabKey: 'messages',
        title: 'influencer.campaign.tabs.messages',
        icon: MessagesIcon,
    },
    {
        tabKey: 'invoices',
        title: 'influencer.campaign.tabs.invoices',
        icon: IconInvoice,
    },
];

const influencerMobileLinks = [
    {
        tabKey: 'dashboard',
        title: 'influencer.campaign.tabs.dashboard',
        icon: DashboardIcon,
    },
    {
        tabKey: 'explore',
        title: 'influencer.campaign.tabs.explore',
        icon: ExploreIcon,
    },
    {
        tabKey: 'offers',
        title: 'influencer.campaign.tabs.offers',
        icon: OffersIcon,
    },
    {
        tabKey: 'more',
        title: 'influencer.campaign.tabs.more',
        icon: CgMoreVertical,
        moreTabs: [
            {
                tabKey: 'invoices',
                title: 'influencer.campaign.tabs.invoices',
                icon: IconInvoice,
            },
            {
                tabKey: 'planner',
                title: 'influencer.campaign.tabs.planner',
                icon: PlannerIcon,
            },
            {
                tabKey: 'reporting',
                title: 'influencer.campaign.tabs.reporting',
                icon: ReportingIcon,
            },
            {
                tabKey: 'messages',
                title: 'influencer.campaign.tabs.messages',
                icon: MessagesIcon,
            },
        ],
    },
];

const influencerDesktopLinks = [
    {
        tabKey: 'dashboard',
        title: 'influencer.campaign.tabs.dashboard',
        icon: DashboardIcon,
    },
    {
        tabKey: 'explore',
        title: 'influencer.campaign.tabs.explore',
        icon: ExploreIcon,
    },
    {
        tabKey: 'offers',
        title: 'influencer.campaign.tabs.offers',
        icon: OffersIcon,
    },
    {
        tabKey: 'planner',
        title: 'influencer.campaign.tabs.planner',
        icon: PlannerIcon,
    },
    {
        tabKey: 'reporting',
        title: 'influencer.campaign.tabs.reporting',
        icon: ReportingIcon,
    },
    {
        tabKey: 'messages',
        title: 'influencer.campaign.tabs.messages',
        icon: MessagesIcon,
    },
    {
        tabKey: 'invoices',
        title: 'influencer.campaign.tabs.invoices',
        icon: IconInvoice,
    },
];

const brandMobileLinks = [
    {
        tabKey: 'dashboard',
        title: 'brand.campaign.tabs.dashboard',
        icon: DashboardIcon,
    },
    {
        tabKey: 'discovery',
        title: 'brand.campaign.tabs.discovery',
        icon: DiscoveryIcon,
    },
    {
        tabKey: 'book',
        title: 'brand.campaign.tabs.book',
        icon: IconBook,
    },
    {
        tabKey: 'contracts',
        title: 'brand.campaign.tabs.contracts',
        icon: IconBook,
    },
    {
        tabKey: 'options',
        title: 'brand.campaign.tabs.options',
        icon: IconBundle,
    },
    {
        tabKey: 'manage',
        title: 'brand.campaign.tabs.manage',
        icon: IconManage,
    },
    {
        tabKey: 'measure',
        title: 'brand.campaign.tabs.measure',
        icon: IconMeasure,
    },
    {
        tabKey: 'messages',
        title: 'brand.campaign.tabs.messages',
        icon: MessagesIcon,
    },
];

const brandDesktopLinks = [
    {
        tabKey: 'dashboard',
        title: 'brand.campaign.tabs.dashboard',
        icon: DashboardIcon,
    },
    {
        tabKey: 'book',
        title: 'brand.campaign.tabs.book',
        icon: IconBook,
    },
    {
        tabKey: 'manage',
        title: 'brand.campaign.tabs.manage',
        icon: IconManage,
    },
    {
        tabKey: 'measure',
        title: 'brand.campaign.tabs.measure',
        icon: IconMeasure,
    },
];
const globalBrandDesktopLinks = [
    {
        tabKey: 'dashboard',
        title: 'brand.campaign.tabs.dashboard',
        icon: DashboardIcon,
    },
    {
        tabKey: 'manage',
        title: 'brand.campaign.tabs.manage',
        icon: IconManage,
    },
    // {
    //     tabKey: 'measure',
    //     title: 'brand.campaign.tabs.measure',
    //     icon: IconMeasure,
    // },
    // {
    //     tabKey: 'statistics',
    //     title: 'brand.campaign.tabs.influencer_kpis',
    //     icon: IconBook,
    // },
];

export const agencyLinks = {
    desktopLinks: agencyDesktopLinks,
    mobileLinks: agencyMobileLinks,
};

export const influencerLinks = {
    desktopLinks: influencerDesktopLinks,
    mobileLinks: influencerMobileLinks,
};

export const brandLinks = {
    desktopLinks: brandDesktopLinks,
    mobileLinks: brandMobileLinks,
};

export const globalBrandLinks = {
    desktopLinks: globalBrandDesktopLinks,
};
